// import React, { useState } from "react";
// import ReactDOM from "react-dom";
// import { Doughnut } from "react-chartjs-2";
// import { Chart as ChartJS } from "chart.js/auto";
// export default function DoughnutGraph() {
//   const [data, setData] = useState({
//     labels: ["January", "February", "March", "April", "May", "June", "July"],
//     datasets: [
//       {
//         label: "User Added",
//         // backgroundColor: "rgb(25,144,208)",
//         // borderColor: "rgb(88,118,212)",
//         backgroundColor: [
//           "rgba(255, 99, 132, 0.2)",
//           "rgba(54, 162, 235, 0.2)",
//           "rgba(255, 206, 86, 0.2)",
//           "rgba(75, 192, 192, 0.2)",
//           "rgba(153, 102, 255, 0.2)",
//           "rgba(255, 159, 64, 0.2)",
//         ],
//         borderColor: [
//           "rgba(255, 99, 132, 1)",
//           "rgba(54, 162, 235, 1)",
//           "rgba(255, 206, 86, 1)",
//           "rgba(75, 192, 192, 1)",
//           "rgba(153, 102, 255, 1)",
//           "rgba(255, 159, 64, 1)",
//         ],
//         borderWidth: 1,
//         //stack: 1,
//         hoverBackgroundColor: "rgb(88,118,212)",
//         hoverBorderColor: "rgb(88,118,215)",
//         data: [65, 59, 80, 81, 56, 55, 40],
//       },
//     ],
//   });

//   const options = {
//     responsive: true,
//     legend: {
//       display: false,
//     },
//     type: "Doughnut",
//     //   scales: {
//     //     xAxes: [{
//     //         stacked: true
//     //     }],
//     //     yAxes: [{
//     //         stacked: true
//     //     }]
//     // }
//   };
//   return <Doughnut data={data} width={null} height={null} options={options} />;
// }import React, { useState } from "react";
// import ReactDOM from "react-dom";
// import React, { useState } from "react";
// import { Doughnut } from "react-chartjs-2";
// import { Chart as ChartJS } from "chart.js/auto";
// import { useSelector } from "react-redux";
// export default function DoughnutGraph({ value: localData }) {
//   const globalData = useSelector((state) => state.dashboardReducer);

//   const [data, setData] = React.useState({
//     labels: [
//       `Pending :${"235"}${"   "}`,
//       `Active  :${"1511"}${"   "}`,
//       `Rejected :${"118"}${"    "}`,
//       `Blocked :${"70"}`,
//       // `Account Status :${"100"}`,
//     ],
//     datasets: [
//       {
//         label: "User Added",
//         // backgroundColor: "rgb(25,144,208)",
//         // borderColor: "rgb(88,118,212)",
//         backgroundColor: [
//           // "#000087",
//           // "#00CBF5",
//           // "Old",
//           // "#DBF2F2",
//           // "#d8d9dd",
//           // "#75d9ef",
//           // "#506C78",
//           // "#000087",
//           // "#9AD0F5",
//           // "#A2EBF5",
//           // "New",
//           "#D81B60",
//           "#2fb74b",
//           "#FF851B",
//           "#1990D0",
//           "#F39C12",
//           "#3C8DBC",
//           "#00C0EF",
//         ],
//         borderColor: [
//           // "rgba(255, 99, 132, 1)",
//           // "rgba(54, 162, 235, 1)",
//           // "rgba(255, 206, 86, 1)",
//           // "rgba(75, 192, 192, 1)",
//           // "rgba(153, 102, 255, 1)",
//           // "rgba(255, 159, 64, 1)",
//           "#D81B60",
//           "#2fb74b",
//           "#FF851B",
//           "#1990D0",
//           "#F39C12",
//           "#3C8DBC",
//           "#00C0EF",
//         ],
//         borderWidth: 1,
//         //stack: 1,
//         hoverBackgroundColor: "rgb(88,118,212)",
//         hoverBorderColor: "rgb(88,118,215)",
//         data: [235, 1511, 118, 70],
//       },
//     ],
//   });

//   const options = {
//     responsive: true,
//     legend: {
//       display: false,
//     },
//     scale: {
//       pointLabels: {
//         fontStyle: "bold",
//         textAlign: "left",
//         alignItems: "left",
//       },
//     },
//     type: "Doughnut",
//     plugins: {
//       legend: {
//         align: "start",
//         title: {
//           position: "start",
//         },
//         labels: {
//           position: "left",
//           font: {
//             // style: "italic",
//             // position: "left",
//             // weight: "600",
//             // textAlign: "left",
//             // alignItems: "left",
//           },
//         },
//       },
//     },
//     //   scales: {
//     //     xAxes: [{
//     //         stacked: true
//     //     }],
//     //     yAxes: [{
//     //         stacked: true
//     //     }]
//     // }
//   };

//   return <Doughnut data={data} width={null} height={null} options={options} />;
// }

// import React, { useState } from "react";
// import ReactDOM from "react-dom";
// import { Doughnut } from "react-chartjs-2";
// import { Chart as ChartJS } from "chart.js/auto";
// export default function DoughnutGraph() {
//   const [data, setData] = useState({
//     labels: ["January", "February", "March", "April", "May", "June", "July"],
//     datasets: [
//       {
//         label: "User Added",
//         // backgroundColor: "rgb(25,144,208)",
//         // borderColor: "rgb(88,118,212)",
//         backgroundColor: [
//           "rgba(255, 99, 132, 0.2)",
//           "rgba(54, 162, 235, 0.2)",
//           "rgba(255, 206, 86, 0.2)",
//           "rgba(75, 192, 192, 0.2)",
//           "rgba(153, 102, 255, 0.2)",
//           "rgba(255, 159, 64, 0.2)",
//         ],
//         borderColor: [
//           "rgba(255, 99, 132, 1)",
//           "rgba(54, 162, 235, 1)",
//           "rgba(255, 206, 86, 1)",
//           "rgba(75, 192, 192, 1)",
//           "rgba(153, 102, 255, 1)",
//           "rgba(255, 159, 64, 1)",
//         ],
//         borderWidth: 1,
//         //stack: 1,
//         hoverBackgroundColor: "rgb(88,118,212)",
//         hoverBorderColor: "rgb(88,118,215)",
//         data: [65, 59, 80, 81, 56, 55, 40],
//       },
//     ],
//   });

//   const options = {
//     responsive: true,
//     legend: {
//       display: false,
//     },
//     type: "Doughnut",
//     //   scales: {
//     //     xAxes: [{
//     //         stacked: true
//     //     }],
//     //     yAxes: [{
//     //         stacked: true
//     //     }]
//     // }
//   };
//   return <Doughnut data={data} width={null} height={null} options={options} />;
// }import React, { useState } from "react";

// {
//   labels: [
//     `Pending :${"235"}`,
//     `Active  :${"1511"}`,
//     `Rejected :${"118"}}`,
//     `Blocked :${"70"}`,
//   ],

//   datasets: [
//     {
//       label: "User Added",

//       backgroundColor: [
//         "#D81B60",
//         "#2fb74b",
//         "#FF851B",
//         "#1990D0",
//         "#F39C12",
//         "#3C8DBC",
//         "#00C0EF",
//       ],

//       borderColor: [
//         "#D81B60",
//         "#2fb74b",
//         "#FF851B",
//         "#1990D0",
//         "#F39C12",
//         "#3C8DBC",
//         "#00C0EF",
//       ],
//       borderWidth: 1,
//       //stack: 1,
//       hoverBackgroundColor: "rgb(88,118,212)",
//       hoverBorderColor: "rgb(88,118,215)",
//       data: [235, 1511, 118, 70],
//     },
//   ],
// }

import ReactDOM from "react-dom";
import React, { useState } from "react";
import {
  Doughnut,
  Chart as DoughnutChart,
  getDatasetAtEvent,
  getElementAtEvent,
} from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";
import { useSelector } from "react-redux";
import { useRef } from "react";
import { useEffect } from "react";
import { Backdrop, Button, Skeleton } from "@mui/material";
import Loader from "../../../components/Loader";
import axios from "axios";
import { toast } from "react-toastify";
import { common_axios } from "../../../App";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import "chartjs-plugin-labels";
import { Chart } from "chart.js";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ChartDataLabels from "chartjs-plugin-datalabels";
import PauseCircleFilledIcon from "@mui/icons-material/PauseCircleFilled";
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import CancelImg from "../../../assets/images/cancel.png";
Chart.register(ChartDataLabels);

export default function DoughnutGraph({ value, api }) {
  const chartRef = useRef(null);
  const history = useHistory();

  const resd = useSelector((data) => data?.dashboardReducer);
  const globalData = useSelector((state) => state.dashboardReducer);
  // console.log({ globalData, localData });

  const [data, setData] = React.useState(null);
  const [data1, setData1] = React.useState(null);
  const [data3, setData3] = React.useState(null);
  const [open, setOpen] = useState(true);
  const assignUserApi = async (e) => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/${api}`,
        {
          campaignRequest: {
            startDateTime: `${resd?.timeSeries?.end}`,
            endDateTime: `${resd?.timeSeries?.start}`,
          },
          role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        let varrr = false;
        res.data["labelObject"] = [];
        for (
          let index = 0;
          index < res.data?.idDataResponse?.data?.length;
          index++
        ) {
          let obj = {};
          obj.label = res.data?.idDataResponse?.label?.[index];
          obj.clicked = false;
          obj.disable = true;
          if (obj.label == "Approved") {
            obj.icon = CheckCircleIcon;
          }
          if (obj.label == "Pending") {
            obj.icon = WatchLaterIcon;
          }
          if (obj.label == "Reject") {
            obj.icon = CancelIcon;
          }
          if (
            res.data?.idDataResponse?.data[index] != 0 &&
            res.data?.idDataResponse?.data[index] != null
          ) {
            varrr = true;
            obj.disable = false;
          }
          res.data["labelObject"].push(obj);
        }

        if (!varrr) {
          setData([]);
        } else {
          setData({
            // labels: res?.data?.label?.map(
            //   (x, index) => `${x} ${res.data[index]}`
            // ),
            labelObject: res?.data?.labelObject,
            labels: res?.data?.idDataResponse?.label,
            // label: "new",
            datasets: [
              {
                // label: "new",
                // backgroundColor: "rgb(25,144,208)",
                backgroundColor: [
                  "#5ab778 ",
                  "#f5ab2e ",
                  "#f9442f ",
                  "#E74747",
                  "#1990D0",
                  "#3C8DBC",
                  "#00C0EF",
                ],

                borderColor: "white",
                // borderColor:,
                borderWidth: 1,
                //stack: 1,
                // hoverBackgroundColor: "rgb(88,118,212)",
                // hoverBorderColor: "rgb(88,118,215)",
                data: res.data?.idDataResponse?.data,
                height: "221px",
                tension: 0.1,
                borderWidth: 5,
              },
            ],
          });
        }

        setOpen(false);
      } else {
        setData([]);
        setOpen(false);
      }
    } catch (error) {
      setData([]);
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(() => {
    assignUserApi();
  }, [
    resd?.timeSeries?.start,
    resd?.timeSeries?.end,

    // resd?.showBy,
  ]);

  const options = {
    responsive: true,
    // legend: {
    //   display: false,
    // },
    // maintainAspectRatio: false,
    scale: {
      pointLabels: {
        fontStyle: "bold",
        textAlign: "left",
        alignItems: "left",
      },
    },
    type: "Doughnut",
    plugins: {
      legend: {
        display: false,
       
      },

      datalabels: {
        display: true,
        color: "white",
        weight: "bolder",
        // font: "bolder 20px Comic Sans MS",
        font: {
          size: "20px",
        },
        align: "center",
        height: "100%",
        // padding: {
        //   right: 2,
        // },
        // labels: {
        //   padding: { top: 0 },
        //   title: {
        //     font: {
        //       weight: "bolder",
        //       size: "30px",
        //     },
        //   },
        //   value: {
        //     color: "white",
        //     weight: "bolder",
        //     size: "20px",
        //   },
        // },
        formatter: function (value, name) {
          if (value != 0) return "\n" + value;
          else return "";
        },
      },
   
    },

    onHover: (event, activeElements) => {
      // console.log({ activeElements });
      if (activeElements?.length > 0) {
        event.native.target.style.cursor = "pointer";
      } else {
        event.native.target.style.cursor = "auto";
      }
    },
    //   scales: {
    //     xAxes: [{
    //         stacked: true
    //     }],
    //     yAxes: [{
    //         stacked: true
    //     }]
    // }
  };

  // useEffect(() => {
  //   const chart = chartRef.current;

  //   if (chart) {
  //     console.log("ChartJS", chart);
  //   }
  //   chart.width = 500;
  // }, []);

  const printDatasetAtEvent = (dataset) => {
    if (!dataset.length) return;

    const datasetIndex = dataset[0].datasetIndex;

    // console.log(data.datasets[datasetIndex].status);

    return data.datasets[datasetIndex].status;
  };

  const printElementAtEvent = (element) => {
    if (!element.length) return;

    const { datasetIndex, index } = element[0];

    // console.log(data.labels[index], data.datasets[datasetIndex].data[index]);
    return data.labels[index];
  };

  const printElementsAtEvent = (elements) => {
    if (!elements.length) return;

    // console.log(elements.length);
    return elements.length;
  };

  const handleClick = (event) => {
    // alert("Now clikced");

    // console.log(
    //   "IIIIIIII",

    //   printElementAtEvent(getElementAtEvent(chartRef.current, event))
    // );

    if (printElementAtEvent(getElementAtEvent(chartRef.current, event))) {
      localStorage?.setItem(
        "dstQueCode1",
        `${printElementAtEvent(getElementAtEvent(chartRef.current, event))},${
          api.split("/")[api.split("/").length - 2]
        }`
      );

      history?.push("/dashboard/Dashboardreports");
    }
    // printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event));
    // printElementAtEvent(getElementAtEvent(chartRef.current, event));
    // printElementsAtEvent(getElementsAtEvent(chartRef.current, event));
  };

  const textCenter = {
    id: "textCenter",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      const { ctx, data } = chart;
      const initialValue = 0;
      const sumWithInitial = data?.datasets?.[0]?.data?.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        initialValue
      );

      ctx.save();
      ctx.textAlign = "center";
      ctx.font = "bolder 20px Comic Sans MS";
      // ctx.fillStyle = "red";
      ctx.fillText(
        `Total :${sumWithInitial}`,
        chart.getDatasetMeta(0).data[0].x,
        chart.getDatasetMeta(0).data[0].y
      );
    },
  };
  const handleButtonClick = async (index) => {
    chartRef.current.legend.chart.toggleDataVisibility(
      chartRef.current.legend.legendItems[index].index
    );
    chartRef.current.update();

    const dataaa = { ...data };

    dataaa.labelObject[index].clicked = !dataaa.labelObject[index].clicked;

    setData(dataaa);
  };

  // console.log("state");

  return (
    <>
      {/* <Backdrop
        sx={{
          transform: "translateZ(0)",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
        // onClick={handleClose}
      >
        <Loader />
      </Backdrop> */}
      {!open && data ? (
        <>
          {data.length == 0 ? (
            <div className="d-flex h-100 p-3">
              <div className="m-auto text-center">
                <h1>No Data</h1>
                <img
                  style={{ width: "100px", maxWidth: "100%" }}
                  src={CancelImg}
                  alt=""
                  srcset=""
                />
              </div>
            </div>
          ) : (
            <>
              <div className="d-flex flex-wrap justify-content-center my-2">
                {data?.labelObject?.map((dataaa, index) => {
                  return (
                    <div>
                      <Button
                        className="m-1 me-"
                        size="small"
                        disabled={dataaa.disable}
                        sx={{
                          borderRadius: 2,
                          boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
                          backgroundColor: !dataaa?.clicked
                            ? data?.datasets?.[0]?.backgroundColor?.[index]
                            : "grey",
                          color: "white",
                          textDecorationColor: "black",
                          textDecoration: dataaa?.clicked
                            ? "line-through"
                            : "none",
                          color: "white",
                        }}
                        variant="contained"
                        startIcon={
                          dataaa?.icon ? <dataaa.icon /> : <CancelIcon />
                        }
                        onClick={() => {
                          handleButtonClick(index);
                        }}
                      >
                        {dataaa?.label}
                      </Button>
                    </div>
                  );
                })}
              </div>
              <DoughnutChart
                type="doughnut"
                ref={chartRef}
                data={data}
                height={null}
                width={null}
                options={options}
                plugins={[textCenter]}
                onClick={handleClick}
              />
            </>
          )}
        </>
      ) : (
        <>
          <Skeleton animation="wave" className="mt-3" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </>
      )}
    </>
  );
}
